import { Box, Flex, Grid, Stack, Text } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';

import { ListEmpty, LoadFailed, NotFoundIcon, Panel, SectionHeading } from '#features/ui';

/**
 * Временная страница сравнения: как выглядел упавший запрос до правки и как теперь.
 * Не входит в продукт, живёт рядом с остальными `/preview/*`.
 */
export const Route = createFileRoute('/{-$locale}/_layout/preview/error-states')({
  component: ErrorStatesPreview,
});

const Col = ({
  label,
  tone,
  children,
}: {
  label: string;
  tone: string;
  children: React.ReactNode;
}) => (
  <Stack gap={3}>
    <Text textStyle="label" color={tone} textTransform="uppercase" letterSpacing="0.08em">
      {label}
    </Text>
    <Panel variant="container">{children}</Panel>
  </Stack>
);

function ErrorStatesPreview() {
  return (
    <Box p={{ base: 4, md: 8 }} maxW="1100px" mx="auto">
      <Stack gap={10}>
        <Stack gap={2}>
          <SectionHeading>Упавший запрос: было и стало</SectionHeading>
          <Text textStyle="body" color="fg.muted" maxW="70ch">
            Слева то, что человек видел при ошибке сети до правки: загрузка кончилась, список
            пустой, и продукт утверждал, что смотреть нечего. Справа — правда и кнопка.
          </Text>
        </Stack>

        <Stack gap={3}>
          <Text textStyle="title">Список внутри экрана (друзья, заблокированные)</Text>
          <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={4}>
            <Col label="Было" tone="fg.error">
              <ListEmpty
                icon={NotFoundIcon}
                title="You don't have any friends yet"
                description="Find teammates in Discover and add them here."
              />
            </Col>
            <Col label="Стало" tone="status.live.fg">
              <LoadFailed variant="list" onRetry={() => {}} />
            </Col>
          </Grid>
        </Stack>

        <Stack gap={3}>
          <Text textStyle="title">Нет связи: отдельный текст, потому что совет другой</Text>
          <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={4}>
            <Col label="Было" tone="fg.error">
              <ListEmpty
                icon={NotFoundIcon}
                title="No sessions are planned right now."
                description="Be the first to schedule one and rally your squad."
              />
            </Col>
            <Col label="Стало" tone="status.live.fg">
              <LoadFailed variant="list" offline onRetry={() => {}} />
            </Col>
          </Grid>
        </Stack>

        <Stack gap={3}>
          <Text textStyle="title">Экран целиком</Text>
          <Flex direction={{ base: 'column', md: 'row' }} gap={4}>
            <Box flex="1">
              <Col label="Стало: страница" tone="status.live.fg">
                <LoadFailed onRetry={() => {}} />
              </Col>
            </Box>
            <Box flex="1">
              <Col label="Стало: без обработчика, кнопки нет" tone="fg.muted">
                <LoadFailed variant="list" />
              </Col>
            </Box>
          </Flex>
        </Stack>
      </Stack>
    </Box>
  );
}
